import { Component, OnInit, Input, ElementRef, ViewChild,Renderer2 } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { ValidatedTextField } from '../../../../validations/validated-text-field.component'
import { NumericTextFieldValidator } from '../../../../validations/numeric-text-field-validator'
import { ValidatedDateTextField } from '../../../../validations/validated-date-text-field.component'
import { BeneficiaryInfo } from '../../../models/enrollments'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { AddressDB } from '../../../../user-management/models/address'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { EmailAddressTextFieldValidator } from '../../../../validations/email-address-text-field-validator'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { RequiredRadioButtonFieldValidator } from '../../../../validations/required-radio-button-field-validator'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { OtherDrugCoverage } from '../../../models/enrollments'
import { DrugPlan } from '../../../models/drug-plan'
import { LicenseApptGateway } from '../../../../user-management/gateways/license-appt-gateway'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { PortalGlobals } from '../../../../portalglobals'
import { stcobModel } from '../../../models/stcob-model'
import { PlanList } from '../../../models/plan-list'
import { Router } from '@angular/router'
import * as moment from 'moment'
import { SubmitEnrollmentDataResponse } from './../../../models/submit-enrollment-data-response'
import { callStartGateway } from '../../../../call-start/gateways/call-start-gateway'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import { isMMDDYYYY } from '../../../../../app/validations/is-mmddyyyy'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { RaceEthnicityComponent } from '../../common/race-ethnicity.component'
import { IndvRepComponent } from '../../common/indvrep.component'

@Component({
    selector: 'NEJEPhoneEnrollmentStep2',
    templateUrl: 'phone-enrollment-step2.component.html',
    styleUrls: ['./phone-enrollment.component.scss']
})
export class NEJEPhoneEnrollmentStep2Component implements OnInit {
    private _raceEthnicityComponent: RaceEthnicityComponent
    @Input() enrollment: BeneficiaryInfo
    @Input() disabled: boolean = false

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef;
    @ViewChild('effectiveDate', { static: false, read: ElementRef }) effectiveDate!: ElementRef;
    @ViewChild('receiptDate', { static: false, read: ElementRef }) receiptDate!: ElementRef;
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    periodSelected = ''
    reasonCode: string = ''
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    validatedDate = new ValidatedDateTextField()
    public rblvalidPeriod: ValidatedRadioButtonModel[] = []
    public rblGrp: ValidatedRadioButtonModel[] = []
    public rblPlan: ValidatedRadioButtonModel[] = []
    public rblSameState: ValidatedRadioButtonModel[] = []
    public rblLanguage: ValidatedRadioButtonModel[] = []
    // public rdBtnEOB: ValidatedRadioButtonModel[] = []
    public rblSecondaryCoverage: ValidatedRadioButtonModel[] = []
    public rbllongTerm: ValidatedRadioButtonModel[] = []
    benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    public IsRblvalidPeriodYes: boolean
    public IsRblvalidPeriodNo: boolean
    showHover: boolean = false
    public IsRblGrpYes: boolean
    public IsRblGrpNo: boolean
    public IsRblSameStateNo: boolean
    public IsRblSameStateYes: boolean

    stcobDetail: stcobModel
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    notBlankValidator = new NotBlankGenericFieldValidator()
    dateTextFieldValidator = new DateTextFieldValidator()
    numericTextFieldValidator = new NumericTextFieldValidator()
    requiredRadioButtonValidator = new RequiredRadioButtonFieldValidator()
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    drugPlanModel = {} as DrugPlan
    states: State[] = [] as State[]
    mailingstates: State[] = [] as State[]
    callrepstates: State[] = [] as State[]
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    public showsubmit: boolean
    public sameAsBusinessAddress = false
    public showCUID: boolean
    public ShowAuthQNo: boolean
    public ShowAuthQNo2No: boolean
    public ShowAuthQNo2Yes: boolean
    public HMOYes: boolean
    public HMONo: boolean
    public UnionYes: boolean
    public UnionNo: boolean

    public PartAYes: boolean
    public PartANo: boolean
    public PartBYes: boolean
    public PartBNo: boolean
    public AnnualAEPYes: boolean = false
    public AnnualAEPNo: boolean = false
    public Script2020: boolean = false
    public Script2023: boolean = false
    public Showfor2023: boolean = false
    visibleFrom2026: boolean
    isPOBox:boolean

    public ExtraHelpCssChange: boolean = false

    public ShowAuthRep: boolean = false

    planYear: number
    planList: PlanList[] = [] as PlanList[]
    selPlan: string
    AppDate: Date
    EffectiveDate: Date
    IsCovergInfoYes: boolean
    IsCovergInfotext: boolean
    hasError: boolean
    ErrorMessages: any[]
    //IsEobYes: boolean
    IsRbllongtermYes: boolean
    IsSameAddress: boolean
    agentUserName: string
    isQtip: boolean
    planstatename: string
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyourhisher: string
    spnYourBeneficiaryNew: string
    AgentFullName: string
    dateField: boolean
    // eobName: string
    insuranceComapny: string
    public loading: boolean = false
    isAEPVisible: boolean
    checkPlanyear: boolean = false
    spnIsBeneficiaryYou: string
    spnyouhimher: string
    spndodoes: string
    spnyoubenef: string
    spnYouheshe: string
    spnYoutheenrollee: string
    spnnameofMedicare: string
    disableEffectiveDate: boolean
    IsRecordCallYes: boolean = false
    IsRecordCallNo: boolean = false
    isAuthRep: boolean = false
    disabledstate = false
    planvalue: string
    planstep: string
    planname: string
    IsRbllongtermNo: boolean = false
    //PaperlessOption: boolean
    public IsAutomatciSocial: boolean
    public IsAUTOMATIC_RAILROAD: boolean
    public IsMonthly: boolean
    public rblRelation: ValidatedSelectOptionModel[] = []
    public rblrecord: ValidatedRadioButtonModel[] = []
    public lblEnrollee: ValidatedRadioButtonModel[] = []
    public rblAuth: ValidatedRadioButtonModel[] = []
    public rblMailCopy: ValidatedRadioButtonModel[] = []
    public paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    public rblLanFormat: ValidatedRadioButtonModel[] = []
    public rblEnroleeWorkStatus: ValidatedRadioButtonModel[] = []
    public rblSpouceWorkStatus: ValidatedRadioButtonModel[] = []
    public rblAccessibility: ValidatedRadioButtonModel[] = []
    visibleFrom2025: boolean
    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private _indvRepComponent: IndvRepComponent,
        private _licenseAppGateway: LicenseApptGateway,
        public _global: PortalGlobals,
        private router: Router,
        private _stateGateway: StateGateway,
        private _callStartGateway: callStartGateway,
        private el: ElementRef, private renderer: Renderer2
    ) {
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollementGateway)
        //  this.enrollmentViewModel.APPDT = moment.utc().format('MM/DD/YYYY')
        this.spnIsBeneficiary = ' enrollee '

        this.rblrecord.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblAccessibility.push(
            { value: '2', htmlLabel: 'Braille' },
            { value: '1', htmlLabel: 'Large Print' },
            { value: '4', htmlLabel: 'Audio CD' }
        )

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.rblAccessibility.push({ value: '8', htmlLabel: 'Data CD' })
        }
        this.rblEnroleeWorkStatus.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblSpouceWorkStatus.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.lblEnrollee.push({ value: 'E', htmlLabel: 'Enrollee' }, { value: 'A', htmlLabel: 'Authorized Rep' })

        this.rblLanFormat.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })

        this.rblvalidPeriod.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblGrp.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblAuth.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblMailCopy.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblPlan.push(
            { value: 'SilverScriptChoice', htmlLabel: 'SilverScript Choice' },
            { value: 'SilverScriptPlus', htmlLabel: 'SilverScript Plus' }
        )
        this.rblSameState.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblLanguage.push({ value: 'English', htmlLabel: 'English' }, { value: 'Spanish', htmlLabel: 'Spanish' })
        //    this.rdBtnEOB.push({ value: 'Yes', htmlLabel: 'YES,   '+ this.spnIsBeneficiary + ' would like to receive Explanation of Benefits statements electronically' }, { value: 'No', htmlLabel: 'NO, '+ this.spnIsBeneficiary + ' would like to receive Explanation of Benefits statements by mail' })
        this.rblSecondaryCoverage.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rbllongTerm.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.IsRblvalidPeriodYes = false
        this.IsRblvalidPeriodNo = false
        this.IsRblGrpYes = false
        this.IsRblGrpNo = false
        this.IsRblSameStateYes = false
        this.IsRblSameStateNo = false
        this.showsubmit = false
        this.IsCovergInfoYes = false
        this.IsCovergInfotext = false
        this.IsSameAddress = true
        this.showCUID = true
        this.IsAutomatciSocial = false
        this.IsAUTOMATIC_RAILROAD = false
        this.IsMonthly = false

        this.planstatename = '(state name)'
        this.ErrorMessages = [] as any[]
        this.disableEffectiveDate = false
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' }, 
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )

        if (Number(this._global.selectedPlanYear) === this._global.Planyear2023) {
            this.Showfor2023 = true
        } else {
            this.Showfor2023 = false
        }
        this.visibleFrom2026 = this._global.selectedPlanYear > this._global.Planyear2025 ? true : false
    }

    ShowAuthRepDetail(authRepInd: string, authRep: string) {
        if (authRep === 'A') {
            this.ShowAuthRep = true
        } else {
            this.ShowAuthRep = false
        }

        if (authRepInd === 'Yes') {
            this.isAuthRep = true
        } else {
            this.isAuthRep = false
        }
        this.ExtraHelpCssChange = true
    }

    SelectAuthRepEnrollee(authRep: string) {
        if (authRep === 'A') {
            this.enrollmentViewModel.AuthOrEnrollee = 'A'
            this.ShowAuthRep = true
            this.enrollmentViewModel.AUTHREPIND = 'Yes'
            this.isAuthRep = true
        } else {
            this.ShowAuthRep = false
            this.enrollmentViewModel.AuthOrEnrollee = 'E'
            this.enrollmentViewModel.AUTHREPIND = 'No'
            this.isAuthRep = false
        }
        this.ExtraHelpCssChange = true
    }

    SelectAuthQues(isYesNo: string) {
        if (isYesNo === 'Yes') {
            this.ShowAuthQNo = false
        }
        if (isYesNo === 'No') {
            this.ShowAuthQNo = true
        }
        this.enrollmentViewModel.authcomplete = isYesNo
    }

    SelectAuthQues2(isYesNo: string) {
        if (isYesNo === 'Yes') {
            this.ShowAuthQNo2Yes = true
            this.ShowAuthQNo2No = false
        }
        if (isYesNo === 'No') {
            this.ShowAuthQNo2Yes = false
            this.ShowAuthQNo2No = true
        }
        this.enrollmentViewModel.enrolleeaware = isYesNo
    }

    toggleImage() {
        this.showHover = !this.showHover
    }

    onBlur() {}
    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (this._global.selectedPlanYear !== undefined) {
            this.planYear = this._global.selectedPlanYear
        }
        if (this._global.currentUser.userProfileName !== undefined) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentViewModel.ISBACK = false

        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step1'])
        }

        if (Number(this.planYear) === this._global.CurrentYear) {
            this.Script2020 = true
        }
        if (Number(this.planYear) === this._global.Planyear2023) {
            this.Script2023 = true
        }
        if (
            this.enrollmentViewModel.POVERIND !== undefined &&
            this.enrollmentViewModel.POVERIND != null &&
            this.enrollmentViewModel.POVERIND != '' &&
            this.enrollmentViewModel.POVERIND === '1') {
            this.poBoxChecked(true)
        }
        else {
            this.poBoxChecked(false)
        }

        //else {
        //    //2019 variables
        //   // this.ShowAuthRep = true
        //    this.Script2020 = false
        //}

        //Get the Paperless settings from config
        //this._enrollementGateway.getPaperlessSetting("NEJEICallPaperlessSetting").subscribe(
        //    data => {
        //        this.PaperlessOption = data
        //        this.enrollmentViewModel.PaperlessSettings = data
        //    })

        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.ISSTCOB = this.enrollmentCacheData.ISSTCOB
                        this.enrollmentViewModel.SINGLEGRPNAME = this.enrollmentCacheData.GroupPlanName
                        this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                        // this.enrollmentViewModel.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                        this.LoadData()

                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step1'])
            }
        } else {
            this.LoadData()
        }
    }

    //ngAfterViewInit() {
    //    setTimeout(() => {
    //        this.RemovedateAriaAtributes(this.effectiveDate1, 'EffectiveDate');
    //        this.RemovedateAriaAtributes(this.receiptDate, 'ReceiptDate');
    //    }, 10000);
    //}

    onDatePickerReady() {
        
            this.RemovedateAriaAtributes(this.effectiveDate, 'EffectiveDate');
            this.RemovedateAriaAtributes(this.receiptDate, 'ReceiptDate');
       
    }

    RemovedateAriaAtributes(dateElement: ElementRef, label: string): void {
        const hostElem = dateElement?.nativeElement;       

        const ariaElems = hostElem.querySelectorAll('[aria-valuenow], [aria-valuetext], [aria-valuemin], [aria-valuemax]');
       
        ariaElems.forEach(elem => {
            this.renderer.removeAttribute(elem, 'aria-valuenow');
            this.renderer.removeAttribute(elem, 'aria-valuetext');
            this.renderer.removeAttribute(elem, 'aria-valuemin');
            this.renderer.removeAttribute(elem, 'aria-valuemax');
        });

        //const attributes = hostElem.attributes;

        //// Collect all aria-* attributes to remove
        //const ariaAttributes: string[] = [];
        //for (let i = 0; i < attributes.length; i++) {
        //    const attrName = attributes[i].name;
        //    if (attrName.startsWith('aria-')) {
        //        ariaAttributes.push(attrName);
        //    }
        //}

        //// Remove them
        //ariaAttributes.forEach(attr => hostElem.removeAttribute(attr));


    }

    LoadData(): void {
        this.isQtip = false
        this.hasError = false
        this.isAEPVisible = false
        this.ShowAuthQNo = false
        this.ShowAuthQNo2Yes = false
        this.ShowAuthQNo2No = false
        this.HMONo = false
        this.HMOYes = false
        this.PartBNo = false
        this.PartBYes = false
        this.PartANo = false
        this.PartAYes = false

        this.loadPlanList()
        this.SelectRblrecordOptions(this.enrollmentViewModel.RBLRECORD)
        this.partAchange(this.enrollmentViewModel.PartAInd)
        this.partBchange(this.enrollmentViewModel.PartBInd)

        this.SelectAuthQues(this.enrollmentViewModel.authcomplete)
        this.SelectAuthQues2(this.enrollmentViewModel.enrolleeaware)
        this.SelectHMO(this.enrollmentViewModel.hmoppo)
        this.unionrblchange(this.enrollmentViewModel.unionrbl)
        this.AEPChange(this.enrollmentViewModel.annualAep)

        // if (Number(this.planYear) === this._global.CurrentYear) {
        //if (this.enrollmentViewModel.AuthOrEnrollee !== '' &&
        //    this.enrollmentViewModel.AuthOrEnrollee !== null &&
        //    this.enrollmentViewModel.AuthOrEnrollee !== undefined
        //) {
        //this.SelectAuthRepEnrollee(this.enrollmentViewModel.AuthOrEnrollee)
        this.ShowAuthRepDetail(this.enrollmentViewModel.AUTHREPIND, this.enrollmentViewModel.AuthOrEnrollee)
        // }
        //}

        if (this.enrollmentViewModel.CUID !== undefined && this.enrollmentViewModel.CUID !== '0000') this.showCUID = true
        else this.showCUID = false

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true
        }

    }
    poBoxChecked(option: boolean) {
        // debugger
        if (option) {
            this.enrollmentViewModel.POVERIND = '1'
            this.isPOBox = true
        }
        else {
            this.enrollmentViewModel.POVERIND = '0'
            this.isPOBox = false
        }

    }
    SelectRblrecordOptions(isRblrecord: string) {
        if (isRblrecord === 'Yes') {
            this.IsRecordCallYes = true
            this.IsRecordCallNo = false            
        }
        if (isRblrecord === 'No') {
            this.IsRecordCallYes = false
            this.IsRecordCallNo = true
        }
        this.enrollmentViewModel.RBLRECORD = isRblrecord
       
    }

    setPageData() {
        if (this.enrollmentViewModel.AGENTORGID !== null && this.enrollmentViewModel.AGENTORGID !== undefined) {
            this._enrollementGateway
                .GetAllParentStatesForOrg(this.enrollmentViewModel.AGENTORGID)
                .subscribe((states: ValidatedSelectOptionModel[]) => {
                    states.unshift({ value: 0, text: '-- Choose One --' })
                    // this.mailingstates = states
                    this.states = states
                    if (
                        this.enrollmentViewModel.APPST === undefined ||
                        this.enrollmentViewModel.APPST === '' ||
                        this.enrollmentViewModel.APPST === '0' ||
                        this.enrollmentViewModel.APPST === null
                    ) {
                        this.enrollmentViewModel.APPST = '0'
                    }
                    //if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0' || this.enrollmentViewModel.MAILST === null) {
                    //    this.enrollmentViewModel.MAILST = '0'
                    //}
                    this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => {
                        states.unshift({ value: 0, text: '-- Choose One --' })
                        this.mailingstates = states
                        if (
                            this.enrollmentViewModel.MAILST === undefined ||
                            this.enrollmentViewModel.MAILST === '' ||
                            this.enrollmentViewModel.MAILST === '0' ||
                            this.enrollmentViewModel.MAILST === null
                        ) {
                            this.enrollmentViewModel.MAILST = '0'
                        }
                    })
                    this.setData()
                })
        } else {
            this.setData()
        }
    }

    setData() {
        this.enrollmentViewModel.isPhoneEnrollment = true
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]

        this.genderOptions = [
            { value: 'M', htmlLabel: 'Male', disabled: this.disabled },
            { value: 'F', htmlLabel: 'Female', disabled: this.disabled }
        ]

        this.paymentOptions = [
            {
                value: 'Direct Bill',
                htmlLabel: 'Receive a bill in the mail that you will pay by check, money order or debit/credit card.'
            },
            {
                value: 'Deduction from Social Security Check',
                htmlLabel: 'Automatically deduct the premium from your Social Security benefit check OR'
            },
            {
                value: 'Deduction from Railroad Retirement Board',
                htmlLabel: 'Automatically deduct the premium from your Railroad Retirement Board benefit check'
            }
        ]

        //this.rdBtnEOB.push({ value: '3', htmlLabel: 'Yes ' }, { value: 'N', htmlLabel: 'No ' })

        this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => {
            states.unshift({ value: 0, text: '-- Choose One --' })
            this.callrepstates = states
            if (
                this.enrollmentViewModel.AUTHREPST === undefined ||
                this.enrollmentViewModel.AUTHREPST === '' ||
                this.enrollmentViewModel.MAILST === '0' ||
                this.enrollmentViewModel.AUTHREPST === null
            ) {
                this.enrollmentViewModel.AUTHREPST = '0'
            }
        })
        // this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        if (this.enrollmentViewModel.PLANYEAR === '2019') {
            this.checkPlanyear = true
        } else {
            this.checkPlanyear = false
        }
        this.AgentFullName =
            (this.enrollmentViewModel.APPFN === null || this.enrollmentViewModel.APPFN === undefined ? '' : this.enrollmentViewModel.APPFN) +
            ' ' +
            (this.enrollmentViewModel.APPLN === null || this.enrollmentViewModel.APPLN === undefined ? '' : this.enrollmentViewModel.APPLN)
        this.setScript()
        let today = new Date()

        if (this.enrollmentViewModel.APPDT === null || this.enrollmentViewModel.APPDT === undefined) {
            this.enrollmentViewModel.APPDT = today
        }
        if (
            this.enrollmentViewModel.RBLVALIDPERIOD !== '' &&
            this.enrollmentViewModel.RBLVALIDPERIOD !== null &&
            this.enrollmentViewModel.RBLVALIDPERIOD !== undefined
        ) {
            this.ShowGroupOptions(this.enrollmentViewModel.RBLVALIDPERIOD)
        }
        if (
            this.enrollmentViewModel.RBLLONGTERM !== '' &&
            this.enrollmentViewModel.RBLLONGTERM !== null &&
            this.enrollmentViewModel.RBLLONGTERM !== undefined
        ) {
            this.ShowrbllongtermOptions(this.enrollmentViewModel.RBLLONGTERM)
        }
        if (this.enrollmentViewModel.RBLGRP !== '' && this.enrollmentViewModel.RBLGRP !== null && this.enrollmentViewModel.RBLGRP !== undefined) {
            this.ShowGroupOptionsGRP(this.enrollmentViewModel.RBLGRP)
        }
        if (
            this.enrollmentViewModel.RBLSAMESTATE !== '' &&
            this.enrollmentViewModel.RBLSAMESTATE !== null &&
            this.enrollmentViewModel.RBLSAMESTATE !== undefined
        ) {
            this.ShowGroupOptionsSameState(this.enrollmentViewModel.RBLSAMESTATE)
        }
        if (this.enrollmentViewModel.OTHCVRG !== '' && this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            this.ShowCoverageInfo(this.enrollmentViewModel.OTHCVRG)
        }
        //if (this.enrollmentViewModel.EOB !== '' &&
        //    this.enrollmentViewModel.EOB !== null &&
        //    this.enrollmentViewModel.EOB !== undefined
        //) {
        //    this.ShowEobEmail(this.enrollmentViewModel.EOB)
        //}
        if (this.enrollmentViewModel.ISSAMEADDRESS !== null && this.enrollmentViewModel.ISSAMEADDRESS !== undefined) {
            this.clickOnSameAsBusinessAddress(this.enrollmentViewModel.ISSAMEADDRESS)
        }
        if (
            this.enrollmentViewModel.ELECTION !== '' &&
            this.enrollmentViewModel.ELECTION !== null &&
            this.enrollmentViewModel.ELECTION !== undefined
        ) {
            this.periodSelectdChanged(this.enrollmentViewModel.ELECTION)
        }
        if (this.enrollmentViewModel.APPST !== '' && this.enrollmentViewModel.APPST !== null && this.enrollmentViewModel.APPST !== undefined) {
            this.SelectState(this.enrollmentViewModel.APPST)
        }
        if (
            this.enrollmentViewModel.CALLOGID !== 0 &&
            this.enrollmentViewModel.CALLOGID !== null &&
            this.enrollmentViewModel.CALLOGID !== undefined
        ) {
            this.isQtip = true
        }
        if (this.enrollmentViewModel.PWO !== '' && this.enrollmentViewModel.PWO !== null && this.enrollmentViewModel.PWO !== undefined) {
            this.paymentOptionChanged(this.enrollmentViewModel.PWO)
        }

        if (
            this.enrollmentViewModel.AUTHREPIND !== '' &&
            this.enrollmentViewModel.AUTHREPIND !== null &&
            this.enrollmentViewModel.AUTHREPIND !== undefined
        ) {
            this.rblAuthorizedRepClick(this.enrollmentViewModel.AUTHREPIND)
        }
        if (
            this.enrollmentViewModel.PLANTYPE !== '' &&
            this.enrollmentViewModel.PLANTYPE !== null &&
            this.enrollmentViewModel.PLANTYPE !== undefined
        ) {
            this.setplanValue(this.enrollmentViewModel.PLANTYPE)
        }
        //if (this.enrollmentViewModel.LANGFORMAT !== '' &&
        //    this.enrollmentViewModel.LANGFORMAT !== null &&
        //    this.enrollmentViewModel.LANGFORMAT !== undefined
        //) {
        //    if (this.enrollmentViewModel.LANGFORMAT === 'N') {
        //        this.enrollmentViewModel.LANGFORMAT ='No'
        //    }
        //    if (this.enrollmentViewModel.LANGFORMAT == '3' ) {
        //        this.enrollmentViewModel.LANGFORMAT = 'Yes'
        //    }
        //}
    }
    loadPlanList() {
        let planyear
        if (this.enrollmentViewModel.PLANYEAR !== undefined) planyear = this.enrollmentViewModel.PLANYEAR
        else planyear = this._global.selectedPlanYear

        this._enrollementGateway.getPlanList(parseInt(this._global.currentUser.orgId), planyear).subscribe((model: PlanList[]) => {
            this.planList = model
            this.planList = this.planList
            this.getPlanList(this.planList)

            this.setPageData()
            //this.setData()
        })
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
        // this.optionrbPlan = this.optionrbPlan.reverse()
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }
    ShowGroupOptions(val: any) {
        if (val === 'Yes') {
            this.IsRblvalidPeriodYes = true
            this.IsRblvalidPeriodNo = false
        }
        if (val === 'No') {
            this.IsRblvalidPeriodYes = false
            this.IsRblvalidPeriodNo = true
        }
        this.enrollmentViewModel.RBLVALIDPERIOD = val
    }
    ShowrbllongtermOptions(val: any) {
        if (val === 'Yes') {
            this.IsRbllongtermYes = true
            this.IsRbllongtermNo = false
        }
        if (val === 'No') {
            this.IsRbllongtermNo = true
            this.IsRbllongtermYes = false
        }
        this.enrollmentViewModel.RBLLONGTERM = val
    }
    ShowGroupOptionsGRP(val: any) {
        if (val === 'Yes') {
            this.IsRblGrpYes = true
            this.IsRblGrpNo = false
        }
        if (val === 'No') {
            this.IsRblGrpYes = false
            this.IsRblGrpNo = true
        }
        this.enrollmentViewModel.RBLGRP = val
    }
    ShowGroupOptionsSameState(val: any) {
        if (val === 'Yes') {
            this.IsRblSameStateYes = true
            this.IsRblSameStateNo = false
            this.showsubmit = true
        }
        if (val === 'No') {
            this.IsRblSameStateYes = false
            this.IsRblSameStateNo = true
            this.showsubmit = false
            //  this.loadPlanList()
        }
        this.enrollmentViewModel.RBLSAMESTATE = val
    }

    unionrblchange(val: string) {
        if (val === 'Yes') {
            this.UnionYes = true
            this.UnionNo = false
        }
        if (val === 'No') {
            this.UnionYes = false
            this.UnionNo = true
        }

        this.enrollmentViewModel.unionrbl = val
    }

    AEPChange(val: string) {
        if (val === 'Yes') {
            this.AnnualAEPYes = true
            this.AnnualAEPNo = false
        }
        if (val === 'No') {
            this.AnnualAEPYes = false
            this.AnnualAEPNo = true
        }
        this.enrollmentViewModel.annualAep = val
    }

    partAchange(val: string) {
        if (val === 'Yes') {
            this.PartAYes = true
            this.PartANo = false
        }
        if (val === 'No') {
            this.PartAYes = false
            this.PartANo = true
        }

        this.enrollmentViewModel.PartAInd = val
    }

    partBchange(val: string) {
        if (val === 'Yes') {
            this.PartBYes = true
            this.PartBNo = false
        }
        if (val === 'No') {
            this.PartBYes = false
            this.PartBNo = true
        }
        this.enrollmentViewModel.PartBInd = val
    }

    SelectHMO(val: string) {
        if (val === 'Yes') {
            this.HMOYes = true
            this.HMONo = false
        }
        if (val === 'No') {
            this.HMOYes = false
            this.HMONo = true
        }

        this.enrollmentViewModel.hmoppo = val
    }
    ShowCoverageInfo(val: any) {
        if (val === 'Yes') {
            this.IsCovergInfoYes = true
            this.IsCovergInfotext = false
            //   this.showsubmit = true
        }
        if (val === 'No') {
            this.IsCovergInfoYes = false
            this.IsCovergInfotext = true
            //  this.showsubmit = true
        }
        this.enrollmentViewModel.OTHCVRG = val
    }
    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollmentViewModel.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollmentViewModel.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
            this.disableEffectiveDate = true
        } else {
            this.disableEffectiveDate = false
        }
    }

    reasonCodeChanged(SelReasonCode: any) {
        this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        this.enrollmentViewModel.ELECTIONTYPEID = SelReasonCode.id
        this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }
    //ShowEobEmail(SelEob: any) {

    //    if (SelEob === '3') {
    //        this.IsEobYes = true
    //        this.enrollmentViewModel.EOB = SelEob
    //    }
    //    if (SelEob === 'N') {
    //        this.IsEobYes = false
    //        this.enrollmentViewModel.EOB = ''
    //    }

    //}
    sepdatechange(option: Date) {
        this.enrollmentViewModel.SEPEFFDT = option
    }
    SelectState(selectstate: string) {
        if (selectstate !== '' && selectstate !== undefined && selectstate !== '0') {
            this.planstatename = selectstate
        }
        this.enrollmentViewModel.APPST = selectstate
        if (this.states !== undefined && this.states !== null) {
            if (this.states.length > 0) this.planstatename = this.states.filter((x) => x.value === selectstate)[0].text
        }
        this.disabledstate = true
    }

    clickOnSameAsBusinessAddress(val: boolean) {
        if (val) {
            this.IsSameAddress = false
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        } else {
            this.IsSameAddress = true
            this.enrollmentViewModel.MAILADD1 = ''
            this.enrollmentViewModel.MAILADD2 = ''
            this.enrollmentViewModel.MAILCITY = ''
            this.enrollmentViewModel.MAILST = ''
            this.enrollmentViewModel.MAILZIP = ''
        }

        //  this.sameAsBusinessAddress = !this.sameAsBusinessAddress
        this.enrollmentViewModel.ISSAMEADDRESS = val
    }

    residentialAddressChanged(address: AddressDB) {
        this.residentialAddress = this.enrollmentViewModel.residentialAddress = address
        this.enrollmentViewModel.APPADD1 = address.addressLine1
        this.enrollmentViewModel.APPADD2 = address.addressLine2
        this.enrollmentViewModel.APPCITY = address.city
        this.enrollmentViewModel.APPST = address.state
        this.enrollmentViewModel.APPZIP = address.zip
    }

    mailingAddressChanged(address: AddressDB) {
        this.mailingAddress = this.enrollmentViewModel.mailingAddress = address
        this.enrollmentViewModel.MAILADD1 = address.addressLine1
        this.enrollmentViewModel.MAILADD2 = address.addressLine2
        this.enrollmentViewModel.MAILCITY = address.city
        this.enrollmentViewModel.MAILST = address.state
        this.enrollmentViewModel.MAILZIP = address.zip
    }

    onBack(): void {
        this.enrollmentViewModel.ISBACK = true
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step1'])
    }
    onPlanChange(planType: string) {
        if (planType !== undefined && planType !== '' && planType !== null) {
            this.enrollmentViewModel.PLANTYPE = planType
            if (this.optionrbPlan !== undefined && this.optionrbPlan !== null) {
                if (this.optionrbPlan.length > 0)
                    this.enrollmentViewModel.PLANTYPENAME = this.optionrbPlan.filter((x) => x.value === planType)[0].htmlLabel
                this.setplanValue(planType)
                this.planname = this.enrollmentViewModel.PLANTYPENAME

                this.getSTCOBDetail(planType, this.enrollmentViewModel.APPST)
            }
        }
    }
    setplanValue(planType: string): void {
        this._enrollementGateway
            .getPlanPremium(this.enrollmentViewModel.AGENTORGID, this.enrollmentViewModel.PLANYEAR, planType, this.enrollmentViewModel.APPST)
            .subscribe((model: string) => {
                this.planvalue = model
                if (planType === 'VALUE') {
                    this.planstep = '1'
                    //this.planvalue = '37.20'
                } else if (planType === 'PREMIER') {
                    this.planstep = '2'
                    //  this.planvalue = '127.90'
                } else {
                    this.planstep = ''
                    this.planvalue = ''
                }
            })
        this.planname = this.enrollmentViewModel.PLANTYPENAME
    }

    getSTCOBDetail(planshortName: string, stateCd: string) {
        this._enrollementGateway.getStcobDetail(this.enrollmentViewModel.AGENTORGID, planshortName, stateCd).subscribe(
            (response: stcobModel) => {
                if (response !== undefined && response !== null) {
                    this.stcobDetail = response

                    this.enrollmentViewModel.ISSTCOB = this.stcobDetail.OptOutFlag.toLowerCase() == 'true' ? true : false
                    this.enrollmentViewModel.CARRIER = this.stcobDetail.PrimaryCarrier
                    this.enrollmentViewModel.ACCOUNT = this.stcobDetail.PrimaryAccount
                    this.enrollmentViewModel.GROUP = this.stcobDetail.PrimaryGroup
                    this.enrollmentViewModel.CUID = this.stcobDetail.CUID
                    this.showCUID = true
                }
            },
            (err) => {}
        )
    }

    formSubmit(): void {
        //      this.router.navigate(['enrollment/neje/phone-enrollment/Step3'])
        this.ErrorMessages = [] as any[]
        this.enrollmentViewModel.AGENTDEX = 'ICALL'
        this.enrollmentViewModel.DEX = 'ICALL'
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '2'
        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
        this.enrollmentViewModel.PLANST = this.enrollmentViewModel.APPST
        this.enrollmentViewModel.LANG = 'English'

        ////if (this.IsEobYes) {
        ////    this.enrollmentViewModel.LANGFORMAT = "3"
        ////    this.enrollmentViewModel.EOB = '3'
        ////}
        ////else {
        ////    this.enrollmentViewModel.LANGFORMAT = "N"
        ////    this.enrollmentViewModel.EOB = 'N'
        ////}

        if (this.enrollmentViewModel.ISSAMEADDRESS) {
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        }
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
        }
        if (!this.isAuthRep) {
            this.enrollmentViewModel.AUTHREPNAME = ''
            this.enrollmentViewModel.AUTHREPPHONE = ''
            this.enrollmentViewModel.AUTHREPREL = ''
            this.enrollmentViewModel.AUTHREPADD1 = ''
            this.enrollmentViewModel.AUTHREPCITY = ''
            this.enrollmentViewModel.AUTHREPST = ''
            this.enrollmentViewModel.AUTHREPZIP = ''
            this.enrollmentViewModel.AUTHREPCOPYIND = ''
            this.enrollmentViewModel.AUTHREPSIGNEDIND = false
        }

        if (!this.Showfor2023) {
            if (this.enrollmentViewModel.LANGFORMAT == undefined) {
                this.enrollmentViewModel.LANGFORMAT = ''
            }
        }
        this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
        this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)

        this.enrollmentViewModel.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(
            this.enrollmentViewModel.selectedEthnicity
        )
        this.enrollmentViewModel.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollmentViewModel.selecteRace)

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (!this.isFormInvalid()) {
            // this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
            //  this.enrollmentViewModel.STEPCODE = '2'
            this.loading = true
            let mailStateCode = this.enrollmentViewModel.MAILST
            let mailZip = this.enrollmentViewModel.MAILZIP
            if (this.enrollmentViewModel.SAMEADDRESS) {
                mailStateCode = '0'
                mailZip = '0'
            }
            //  this.router.navigate(['enrollment/neje/phone-enrollment/Step3'])

            this._enrollementGateway
                .validateZipForAll(
                    this.enrollmentViewModel.APPST,
                    this.enrollmentViewModel.APPZIP,
                    mailStateCode,
                    mailZip,
                    this.enrollmentViewModel.AUTHREPST,
                    this.enrollmentViewModel.AUTHREPZIP
            )
                .subscribe(
                    (model: string[]) => {
                        if (model !== undefined && model !== null && model.length !== 0) {
                            this.ErrorMessages = model
                            this.hasError = true
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                this.loading = false
                            
                        } else {
                            //Remove Data fro the Individual
                            if (!(this.enrollmentViewModel.INDREPIND === 'Yes')) {
                                this._indvRepComponent.selectedNo(this.enrollmentViewModel)
                            }

                            if (this.enrollmentViewModel.ENROLLKEY !== undefined && this.enrollmentViewModel.ENROLLKEY !== '') {
                                console.log('EnrollmentKey: ' + this.enrollmentViewModel.ENROLLKEY)

                                this._enrollementGateway.UpdateEnrollmentData(this.enrollmentViewModel).subscribe(
                                    (model: SubmitEnrollmentDataResponse) => {
                                        let response = model
                                        if (response !== undefined) {
                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                this.hasError = true

                                                for (let i = 0; i < response.Errors.length; i++) {
                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                }
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            } else {
                                                //this.enrollment.ENROLLKEY = response.EnrollmentKey
                                                //this.enrollment.CONF = response.confirmationNumber
                                                this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                this.loading = false
                                                this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step3'])
                                            }
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }
                                        this.loading = false
                                    },
                                    (err) => {
                                        this.loading = false
                                    }
                                )
                            } else {
                                this._enrollementGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                                    (model: SubmitEnrollmentDataResponse) => {
                                        let response = model
                                        if (response !== undefined) {
                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                this.hasError = true

                                                for (let i = 0; i < response.Errors.length; i++) {
                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                }
                                                this.hasError = true
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            } else {
                                                if (
                                                    response.EnrollmentKey !== undefined &&
                                                    response.EnrollmentKey !== '' &&
                                                    response.EnrollmentKey !== null
                                                ) {
                                                    this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey
                                                    this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                    this.loading = false

                                                    this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                                    this.enrollmentCacheData.AgentName = this.enrollmentViewModel.AGENTNAME
                                                    this.enrollmentCacheData.AgentID = this.enrollmentViewModel.AGENTID
                                                    this.enrollmentCacheData.AdminID = this.enrollmentViewModel.ADMINID
                                                    this.enrollmentCacheData.AgentOrgID = this.enrollmentViewModel.AGENTORGID
                                                    this.enrollmentCacheData.PLANTYPENAME = this.enrollmentViewModel.PLANTYPENAME
                                                    this.enrollmentCacheData.USERNAME = this.enrollmentViewModel.USERNAME
                                                    this.enrollmentCacheData.ISSTCOB = this.enrollmentViewModel.ISSTCOB
                                                    this.enrollmentCacheData.GroupPlanName = this.enrollmentViewModel.SINGLEGRPNAME
                                                    this.enrollmentCacheData.SEPREASONTEXT = this.enrollmentViewModel.SEPREASONTEXT
                                                    //  this.enrollmentCacheData.PaperlessSettings = this.enrollmentViewModel.PaperlessSettings

                                                    sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                                    this.router.navigate(['/' + insCo + '/enrollment/neje/phone-enrollment/Step3'])
                                                } else {
                                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                                    this.hasError = true
                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                }
                                            }
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }
                                        this.loading = false
                                    },
                                    (err) => {
                                        this.loading = false
                                    }
                                )
                            }
                        }
                    },
                    (err) => {
                        this.loading = false
                    }
                )
        } else {
           window.scrollTo({ top: 0, behavior: 'smooth' });    
        }
        // this.validateForm()
    }
    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    validateForm() {}
    paymentOptionChanged(option: string) {
        if (option === 'Deduction from Social Security Check') {
            this.IsAutomatciSocial = true
            //this.IsAUTOMATIC_RAILROAD = false
            //this.IsElectronicFund = false
            this.IsMonthly = false
            //this.IsSelectPlan = false
        }
        if (option === 'Deduction from Railroad Retirement Board') {
            this.IsAutomatciSocial = true
            //this.IsAUTOMATIC_RAILROAD = true
            //this.IsElectronicFund = false
            this.IsMonthly = false
            //this.IsSelectPlan = false
        }
        if (option === 'Direct Bill') {
            this.IsAutomatciSocial = false
            //this.IsAUTOMATIC_RAILROAD = false
            //this.IsElectronicFund = false
            this.IsMonthly = true
            //this.IsSelectPlan = false
        }
        this.enrollmentViewModel.PWO = option
    }
    isFormInvalid(): boolean {
        this.hasError = false
        if (this.enrollmentViewModel.CUID === undefined || this.enrollmentViewModel.CUID === '' || this.enrollmentViewModel.CUID === null || this.enrollmentViewModel.CUID === '0000') {
            this.enrollmentViewModel.PLANTYPE = '';
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPFN === undefined || this.enrollmentViewModel.APPFN === '' || this.enrollmentViewModel.APPFN === null) {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPLN === undefined || this.enrollmentViewModel.APPLN === '' || this.enrollmentViewModel.APPLN === null) {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }

        if (
            this.enrollmentViewModel.APPDOB === undefined ||
            this.enrollmentViewModel.APPDOB === null ||
            this.enrollmentViewModel.APPDOB.toString() == ''
        ) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

            if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                this.hasError = true
            } else if (dob.isSameOrBefore('12/31/1889')) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Date of Birth.')
            } else if (dob > moment()) {
                this.ErrorMessages.push('Date of Birth cannot be in the future')
                this.hasError = true
            }
        }

        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.APPGEN === undefined || this.enrollmentViewModel.APPGEN === '' || this.enrollmentViewModel.APPGEN === null) {
            this.ErrorMessages.push('Sex is required')
            this.hasError = true
            console.log('GENDER selcted inside :' + this.enrollmentViewModel.APPGEN)
        }
        if (this.enrollmentViewModel.APPADD1 === undefined || this.enrollmentViewModel.APPADD1 === '' || this.enrollmentViewModel.APPADD1 === null) {
            this.ErrorMessages.push('Address1 is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPCITY === undefined || this.enrollmentViewModel.APPCITY === '' || this.enrollmentViewModel.APPCITY === null) {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-. ]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPZIP === undefined || this.enrollmentViewModel.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILADD1 === undefined || this.enrollmentViewModel.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address1 is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILCITY === undefined || this.enrollmentViewModel.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-. ]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
        //    if (!isCityValid) {
        //        this.hasError = true
        //        this.ErrorMessages.push('Please enter valid Mailing City')
        //    }
        //}
        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILZIP === undefined || this.enrollmentViewModel.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }
        if (
            this.enrollmentViewModel.ELECTION === undefined ||
            this.enrollmentViewModel.ELECTION === null ||
            this.enrollmentViewModel.ELECTION === ''
        ) {
            this.ErrorMessages.push('Election Status is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.ELECTION !== undefined && this.enrollmentViewModel.ELECTION !== '') {
            //
            // if (this.enrollmentViewModel.ELECTION !== undefined && this.enrollmentViewModel.ELECTION !== '') {
            if (
                this.enrollmentViewModel.ELECTION === 'OpenEnrollment' &&
                this.enrollmentViewModel.APPDT != undefined &&
                this.enrollmentViewModel.APPDT != null
            ) {
                // let appdate = moment(this.enrollmentViewModel.APPDT, 'MM/DD/YYYY')
                let appdateTime = moment(this.enrollmentViewModel.APPDT)

                let appdate = moment({
                    year: appdateTime.year(),
                    month: appdateTime.month(),
                    day: appdateTime.date()
                })
                if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                    if (appdate.isAfter('12/07/' + moment().format('YYYY'))) {
                        //if ((appdate < ("10/15/" + moment().format('YYYY'))) && (appdate> ("12/07/" + moment().format('YYYY'))))
                        this.ErrorMessages.push('App date should be between 10/15 and 12/07 for Annual')
                        this.hasError = true
                    } else {
                        this.ErrorMessages.push('Enrollment Criteria is required')
                        this.hasError = true
                    }
                }
            } else {
                if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                    this.ErrorMessages.push('Enrollment Criteria is required')
                    this.hasError = true
                }
            }
            //
            //if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
            //    this.ErrorMessages.push('Enrollment Criteria is required')
            //    this.hasError = true
            //}
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasError = true
                    }
                }
            }
        }
        if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            if (this.enrollmentViewModel.APPDT !== undefined || this.enrollmentViewModel.APPDT !== null) {
                if (this.enrollmentViewModel.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
                    this.ErrorMessages.push('Application date must be prior to the effective date.')
                    this.hasError = true
                }
            }

            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }

        //if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === '') {
        //    this.ErrorMessages.push('Preferred Language is required')
        //    this.hasError = true
        //}
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PLANST === undefined || this.enrollmentViewModel.PLANST === '') {
            this.ErrorMessages.push('Plan State is required')
            this.hasError = true
        }

        //if (this.enrollmentViewModel.HICN === undefined || this.enrollmentViewModel.HICN === null || this.enrollmentViewModel.HICN === '') {
        //    this.ErrorMessages.push('Medicare Number is required')
        //    this.hasError = true

        //}
        if (this.enrollmentViewModel.PLANTYPE === undefined || this.enrollmentViewModel.PLANTYPE === '') {
            this.ErrorMessages.push('Plan Type is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === undefined || this.enrollmentViewModel.PWO === null) {
            this.ErrorMessages.push('Premium Payment is required')
            this.hasError = true
        }

        if (this.Showfor2023) {
            if (this.enrollmentViewModel.LANGFORMAT === undefined || this.enrollmentViewModel.LANGFORMAT === null) {
                this.ErrorMessages.push('Please select Large Print option.')
                this.hasError = true
            }
        }

        if (this.enrollmentViewModel.APPPHONE === undefined || this.enrollmentViewModel.APPPHONE === '') {
            this.ErrorMessages.push('Phone number is required')
            this.hasError = true
        }
        if (
            this.enrollmentViewModel.RBLLONGTERM === undefined ||
            this.enrollmentViewModel.RBLLONGTERM === null ||
            this.enrollmentViewModel.RBLLONGTERM === ''
        ) {
            this.ErrorMessages.push('Long Term Care Facility is required')
            this.hasError = true
        }
        /*
        if (this.PaperlessOption) {
            //if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB === null) {
            //    this.ErrorMessages.push('Paperless Documents preference is required')
            //    this.hasError = true
            //}

            //{
            if (this.enrollmentViewModel.EOB === '3') {
                if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '' || this.enrollmentViewModel.APPEMAIL === null) {
                    this.ErrorMessages.push('Paperless Documents email is required')
                    this.hasError = true

                }
            }
            //}
        }
        */

        // if (this.Script2020) {
        if (this.enrollmentViewModel.AuthOrEnrollee === undefined || this.enrollmentViewModel.AuthOrEnrollee === '') {
            this.ErrorMessages.push('Please select Enrollee or Authorized Rep')
            this.hasError = true
        }

        if (this.enrollmentViewModel.AuthOrEnrollee === 'A') {
            if (this.enrollmentViewModel.authcomplete === undefined || this.enrollmentViewModel.authcomplete === '') {
                this.ErrorMessages.push('Select Is authorized representative authorized to complete')
                this.hasError = true
            }
            if (this.enrollmentViewModel.enrolleeaware === undefined || this.enrollmentViewModel.enrolleeaware === '') {
                this.ErrorMessages.push('Please select is enrollee aware')
                this.hasError = true
            }

            if (this.enrollmentViewModel.AUTHREPIND === undefined || this.enrollmentViewModel.AUTHREPIND === null) {
                this.ErrorMessages.push('Authorized Representative is required')
                this.hasError = true
            }
        }
        // }
        //else {
        //    if (this.enrollmentViewModel.authcomplete === undefined || this.enrollmentViewModel.authcomplete === '') {

        //        this.ErrorMessages.push('Select Is authorized representative authorized to complete')
        //        this.hasError = true

        //    }
        //    if (this.enrollmentViewModel.enrolleeaware === undefined || this.enrollmentViewModel.enrolleeaware === '') {

        //        this.ErrorMessages.push('Please select is enrollee aware')
        //        this.hasError = true
        //    }

        //    if (this.enrollmentViewModel.AUTHREPIND === undefined || this.enrollmentViewModel.AUTHREPIND === null) {
        //        this.ErrorMessages.push('Authorized Representative is required')
        //        this.hasError = true

        //    }

        //}

        //if (this.enrollmentViewModel.PartAInd === undefined || this.enrollmentViewModel.PartAInd === '') {

        //    this.ErrorMessages.push('Please Select Medicare Part A')
        //    this.hasError = true

        //}
        //if (this.enrollmentViewModel.PartBInd === undefined || this.enrollmentViewModel.PartBInd === '') {

        //    this.ErrorMessages.push('Please Select Medicare Part B')
        //    this.hasError = true

        //}

        if (this.enrollmentViewModel.hmoppo === undefined || this.enrollmentViewModel.hmoppo === '') {
            this.ErrorMessages.push('Please Select Medicare Advantage Plan')
            this.hasError = true
        }

        if (this.enrollmentViewModel.unionrbl === undefined || this.enrollmentViewModel.unionrbl === '') {
            this.ErrorMessages.push('Please Select Health Coverage')
            this.hasError = true
        }
        if (this.enrollmentViewModel.annualAep === undefined || this.enrollmentViewModel.annualAep === '') {
            this.ErrorMessages.push('Please Select Annual Enrollment Period ')
            this.hasError = true
        }

        if (this.enrollmentViewModel.RBLLONGTERM === 'Yes') {
            if (this.enrollmentViewModel.LTCFACILITY === undefined || this.enrollmentViewModel.LTCFACILITY === '') {
                this.ErrorMessages.push('Long Term Care Name is required.')
                this.hasError = true
            }

            if (this.enrollmentViewModel.LTCPHONE === undefined || this.enrollmentViewModel.LTCPHONE === '') {
                this.ErrorMessages.push('Long Term Care Phone is required.')
                this.hasError = true
            }

            if (this.enrollmentViewModel.LTCADD1 === undefined || this.enrollmentViewModel.LTCADD1 === '') {
                this.ErrorMessages.push('Long Term Care Address is required.')
                this.hasError = true
            }
        }
        if (
            this.enrollmentViewModel.LTCFACILITY !== undefined &&
            this.enrollmentViewModel.LTCFACILITY !== '' &&
            this.enrollmentViewModel.LTCFACILITY !== null
        ) {
            let checkltcfacility = this.enrollmentViewModel.LTCFACILITY,
                regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
            let isLtcFacility = regexCovGroupVal.test(checkltcfacility)
            if (!isLtcFacility) {
                this.hasError = true
                this.ErrorMessages.push('Long Term Care Name is invalid')
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === 'Yes') {
            if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                this.ErrorMessages.push('Name of other coverage is required.')
                this.hasError = true
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === 'Yes') {
            if (
                this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                this.enrollmentViewModel.OTHCVRGNAME !== null
            ) {
                let regexCoverageName = /^[A-Za-z\s\-\' ]+$/
                let checkCoverageName = this.enrollmentViewModel.OTHCVRGNAME,
                    regexCoverageNameVal = new RegExp(regexCoverageName)
                let isCovnameValid = regexCoverageNameVal.test(checkCoverageName)
                if (!isCovnameValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Name is invalid')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGID !== undefined &&
                this.enrollmentViewModel.OTHCVRGID !== '' &&
                this.enrollmentViewModel.OTHCVRGID !== null
            ) {
                let checkCoverageID = this.enrollmentViewModel.OTHCVRGID,
                    regexCoverageIDVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovIDValid = regexCoverageIDVal.test(checkCoverageID)
                if (!isCovIDValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Id is invalid')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                this.enrollmentViewModel.OTHCVRGGRP !== null
            ) {
                let checkCoverageGroup = this.enrollmentViewModel.OTHCVRGGRP,
                    regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovGroupValid = regexCovGroupVal.test(checkCoverageGroup)
                if (!isCovGroupValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Group is invalid')
                }
            }
            if (this.enrollmentViewModel.COBBIN !== undefined && this.enrollmentViewModel.COBBIN !== '' && this.enrollmentViewModel.COBBIN !== null) {
                let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                    regexcheckCOBBINVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isRxBinValid = regexcheckCOBBINVal.test(checkCOBBIN)
                if (!isRxBinValid) {
                    this.hasError = true
                    this.ErrorMessages.push('OtherCoverageBin is invalid')
                }
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }

        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.APPEMAIL !== undefined &&
            this.enrollmentViewModel.APPEMAIL !== '' &&
            this.enrollmentViewModel.APPEMAIL !== null
        ) {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()
            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.ErrorMessages.push('Email Address is invalid.')
            }
            //this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
            //this.hasError = true
        }

        if (this.isAuthRep) {
            if (this.enrollmentViewModel.AUTHREPNAME === undefined || this.enrollmentViewModel.AUTHREPNAME === '') {
                this.ErrorMessages.push('Authorized Representative Name is required')
                this.hasError = true
            } else if (
                this.enrollmentViewModel.AUTHREPNAME !== undefined &&
                this.enrollmentViewModel.AUTHREPNAME !== '' &&
                this.enrollmentViewModel.AUTHREPNAME !== null
            ) {
                //let checkAUTHREPNAME = this.enrollmentViewModel.AUTHREPNAME
                //let regexCityVal = /^[A-Za-z\s\-. ]+$/
                //let isAUTHREPNAMEValid = regexCityVal.test(checkAUTHREPNAME)
                //if (!isAUTHREPNAMEValid) {
                //    this.hasError = true
                //    this.ErrorMessages.push('Authorized Representative Name is invalid')
                //}
            }
            if (this.enrollmentViewModel.AUTHREPREL === undefined || this.enrollmentViewModel.AUTHREPREL === '') {
                this.ErrorMessages.push('Authorized Representative Relationship is required')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.AUTHREPST === undefined ||
                this.enrollmentViewModel.AUTHREPST === '' ||
                this.enrollmentViewModel.AUTHREPST === null ||
                this.enrollmentViewModel.AUTHREPST === '0'
            ) {
                this.ErrorMessages.push('Authorized Representative State is required')
                this.hasError = true
            }

            if (this.enrollmentViewModel.AUTHREPCOPYIND === undefined || this.enrollmentViewModel.AUTHREPCOPYIND === '') {
                this.ErrorMessages.push('Authorized Representative Duplicate copy of plan materials is required')
                this.hasError = true
            }

            if (this.enrollmentViewModel.AUTHREPADD1 === undefined || this.enrollmentViewModel.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Authorized Representative Address is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPCITY === undefined || this.enrollmentViewModel.AUTHREPCITY === '') {
                this.ErrorMessages.push('Authorized Representative City is required')
                this.hasError = true
            } else {
                let regexCityVal = /^[A-Za-z\s\-. ]+$/

                let isCityValid = regexCityVal.test(this.enrollmentViewModel.AUTHREPCITY)
                if (!isCityValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter Authorized Representative valid City')
                }
            }

            if (this.enrollmentViewModel.AUTHREPZIP === undefined || this.enrollmentViewModel.AUTHREPZIP === '') {
                this.ErrorMessages.push('Authorized Representative Zip is required')
                this.hasError = true
            } else if (
                this.enrollmentViewModel.AUTHREPZIP !== undefined &&
                this.enrollmentViewModel.AUTHREPZIP !== '' &&
                this.enrollmentViewModel.AUTHREPZIP !== null
            ) {
                let checkZipCode = this.enrollmentViewModel.AUTHREPZIP,
                    regexVal = new RegExp('[0-9]{5}')
                let isZipCodeValid = regexVal.test(checkZipCode)
                if (!isZipCodeValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative Zip is invalid')
                }
            }

            if (this.enrollmentViewModel.AUTHREPPHONE === undefined || this.enrollmentViewModel.AUTHREPPHONE === '') {
                this.ErrorMessages.push('Authorized Representative Phone is required')
                this.hasError = true
            }

            if (
                this.enrollmentViewModel.AUTHREPPHONE !== undefined &&
                this.enrollmentViewModel.AUTHREPPHONE !== '' &&
                this.enrollmentViewModel.AUTHREPPHONE !== null
            ) {
                let checkOrgPhone = this.enrollmentViewModel.AUTHREPPHONE.replace(/-/g, '')
                if (/^\d{10}$/.test(checkOrgPhone)) {
                } else {
                    if (!this.isValidNumber(checkOrgPhone)) {
                        this.ErrorMessages.push('Authorized Representative Phone cannot contain letters or special characters.')
                        this.hasError = true
                    } else {
                        this.ErrorMessages.push('Authorized Representative Phone must be exactly 10 numbers.')
                        this.hasError = true
                    }
                }
            }
            if (this.enrollmentViewModel.AUTHREPEMAIL !== undefined && this.enrollmentViewModel.AUTHREPEMAIL !== '') {
                let isOrgEmailValid = this.isValidEmail(this.enrollmentViewModel.AUTHREPEMAIL)
                if (!isOrgEmailValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative Email is invalid.')
                }
            }
        }
        if (this.enrollmentViewModel.INDREPIND === 'Yes') {
            if (
                this.enrollmentViewModel.INDREPNAME === undefined ||
                this.enrollmentViewModel.INDREPNAME === null ||
                this.enrollmentViewModel.INDREPNAME == ''
            ) {
                this.ErrorMessages.push('Individual Rep Name is required')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.RELTOENROLL === undefined ||
                this.enrollmentViewModel.RELTOENROLL === null ||
                this.enrollmentViewModel.RELTOENROLL == ''
            ) {
                this.ErrorMessages.push('Relationship to enrollee is required')
                this.hasError = true
            }
            if (
                (this.enrollmentViewModel.displayRELTOENROLL == 'Agent' || this.enrollmentViewModel.displayRELTOENROLL == 'Broker') &&
                (this.enrollmentViewModel.NPN === undefined || this.enrollmentViewModel.NPN === null || this.enrollmentViewModel.NPN == '')
            ) {
                this.ErrorMessages.push('National Producer Number is required')
                this.hasError = true
            }
        }
        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    setScript() {
        if (this.AgentFullName !== ' ' && this.AgentFullName !== '' && this.AgentFullName !== 'undefined undefined') {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spnIsBeneficiaryYou = 'enrollee'
            this.spndodoes = 'does'
            this.spnyoubenef = 'the beneficiary'
            this.spnYoutheenrollee = this.AgentFullName
            this.spnnameofMedicare = this.AgentFullName
            if (this.enrollmentViewModel.TITLE === 'Mr' || this.enrollmentViewModel.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
            } else if (
                this.enrollmentViewModel.TITLE === 'Mrs' ||
                this.enrollmentViewModel.TITLE === 'Ms' ||
                this.enrollmentViewModel.APPGEN === 'F'
            ) {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
            } else {
                this.spnyouheshe = '(he/she)'
                this.spnyourhisher = '(his/her)'
                this.spnyouhimher = '(him/her)'
                this.spnYouheshe = '(he/she)'
            }
        } else if (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '') {
            this.spnIsBeneficiary = ' enrollee’s name'
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = '(he/she)'
            this.spnyourhisher = '(his/her)'
            this.spnIsBeneficiaryYou = 'enrollee'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = '(him/her)'
            this.spndodoes = 'does'
            this.spnyoubenef = 'the beneficiary'
            this.spnYouheshe = '(he/she)'
            this.spnYoutheenrollee = 'the enrollee name'
            this.spnnameofMedicare = 'name of Medicare beneficiary'
        } else this.enrollmentViewModel.RBLBENFE === undefined || this.enrollmentViewModel.RBLBENFE === ''
        {
            this.spnIsBeneficiary = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyourhisher = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnIsBeneficiaryYou = 'you'
            this.spnyouhimher = 'you'
            this.spndodoes = 'do'
            this.spnyoubenef = 'you'
            this.spnYouheshe = 'You'
            this.spnYoutheenrollee = 'you'
            this.spnnameofMedicare = 'you'
        }
    }

    AEPVisible(event: any) {
        if (event) {
            this.isAEPVisible = true
        }
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    appRecievedDateChange(event: any) {
        this.enrollmentViewModel.APPDT = event
        if (
            this.enrollmentViewModel.APPDT !== undefined &&
            this.enrollmentViewModel.APPDT !== null &&
            (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null)
        ) {
            let currDate = event
            if (currDate.getMonth() == 11) {
                this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollmentViewModel.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear())
                        this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
        }
    }

    SelectGender(event: any) {
        this.enrollmentViewModel.APPGEN = event
        if (this.enrollmentViewModel.RBLBENFE == 'No') {
            if (this.enrollmentViewModel.TITLE === 'Mr' || this.enrollmentViewModel.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
            } else if (
                this.enrollmentViewModel.TITLE === 'Mrs' ||
                this.enrollmentViewModel.TITLE === 'Ms' ||
                this.enrollmentViewModel.APPGEN === 'F'
            ) {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
            } else {
                this.spnyouheshe = '(he/she)'
                this.spnyourhisher = '(his/her)'
                this.spnyouhimher = '(him/her)'
                this.spnYouheshe = '(he/she)'
            }
        }
    }
    medicareNumberValueChange(event: any) {
        this.enrollmentViewModel.HICN = event.toUpperCase()
    }

    HICNBlur() {
        if (this.enrollmentViewModel.HICN !== undefined && this.enrollmentViewModel.HICN.indexOf('-') >= 0) {
            let re = /\-/gi
            let updatedHICN = this.enrollmentViewModel.HICN.replace(re, '')
            this.enrollmentViewModel.HICN = updatedHICN.toUpperCase()
        }
    }

    rblAuthorizedRepClick(isRblAuth: string) {
        if (isRblAuth === 'Yes') {
            this.isAuthRep = true
        }
        if (isRblAuth === 'No') {
            this.isAuthRep = false
        }
        this.enrollmentViewModel.AUTHREPIND = isRblAuth
    }
    FirstNameChange(event: any) {
        this.enrollmentViewModel.APPFN = event
        if (
            this.enrollmentViewModel.APPFN !== undefined &&
            this.enrollmentViewModel.APPFN !== '' &&
            this.enrollmentViewModel.APPFN !== null &&
            this.enrollmentViewModel.APPLN !== undefined &&
            this.enrollmentViewModel.APPLN !== '' &&
            this.enrollmentViewModel.APPLN !== null
        ) {
            this.AgentFullName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
            this.setScript()
        }
    }

    LastNameChange(event: any) {
        this.enrollmentViewModel.APPLN = event
        if (
            this.enrollmentViewModel.APPFN !== undefined &&
            this.enrollmentViewModel.APPFN !== '' &&
            this.enrollmentViewModel.APPFN !== null &&
            this.enrollmentViewModel.APPLN !== undefined &&
            this.enrollmentViewModel.APPLN !== '' &&
            this.enrollmentViewModel.APPLN !== null
        ) {
            this.AgentFullName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
            this.setScript()
        }
    }
    onAppdatechange(event: any) {
        if (this.enrollmentViewModel.APPDT == null) {
            this.enrollmentViewModel.OldAppDT = new Date('01/01/1900')
        } else {
            this.enrollmentViewModel.OldAppDT = this.enrollmentViewModel.APPDT
        }
        this.enrollmentViewModel.APPDT = event
    }

    //eobOptionChanged(option: boolean) {
    //    if (option === true) {
    //        this.enrollmentViewModel.EOB = '3'
    //        this.IsEobYes = true
    //    } else {
    //        this.enrollmentViewModel.EOB = ''
    //        this.IsEobYes = false
    //    }

    //}
}
